"use strict";
exports.__esModule = true;
exports.forDOMContentLoaded = void 0;
function forDOMContentLoaded() {
    return new Promise(function (resolve) {
        document.addEventListener('DOMContentLoaded', function () {
            resolve();
        });
    });
}
exports.forDOMContentLoaded = forDOMContentLoaded;
